<template>
  <div class="audience-hub-dashboard-header">
    <div class="audience-hub-dashboard-header__title-area">
      <div class="audience-hub-dashboard-header__title">Audience Matters - {{ title }}</div>
    </div>
    <div class="audience-hub-dashboard-header__right-area">
      <span
        v-if="showUserProfile"
        class="audience-hub-dashboard-header__user-profile"
      >
        {{ userRoles }}
      </span>
      <span>
        <action-button
          dark
          class="audience-hub-dashboard-header__create-target"
          @click.native="createNewTarget"
          color="primary"
          label="New Segment"
          id="newSegment"
        />
      </span>
      <span class="audience-hub-dashboard-header__notifications">
        <audience-matters-notifications />
      </span>
      <span
        class="audience-hub-dashboard-header__username"
        :class="{ headerMenuClickable: doesUserHaveAdminPermissions }"
        @click="expandHeaderMenu"
      >
        {{ username }}
      </span>
    </div>
    <stepper-modal />
    <send-downstream
      ref="sendDownstreamModal"
      :value="initialTargetCopy"
    />
    <template>
      <modal
        title="Select Intent"
        ref="modal"
        :width="500"
        closeButton
        hideActions
      >
        <template>
          <div class="audience-hub-dashboard-header__select-intent-actions">
            <action-button
              v-if="intents.some(v => v === Sales)"
              dark
              @click.native="intentSelected(Sales)"
              label="Sales"
              color="primary"
              id="salesIntent"
            />
            <action-button
              v-if="intents.some(v => v === Marketing)"
              dark
              @click.native="intentSelected(Marketing)"
              label="Marketing"
              color="primary"
              id="marketingIntent"
            />
            <action-button
              v-if="intents.some(v => v === Research)"
              dark
              @click.native="intentSelected(Research)"
              label="Research"
              color="primary"
              id="researchIntent"
            />
          </div>
        </template>
      </modal>
    </template>
  </div>
</template>

<script>
  import AudienceMattersNotifications from '@/appComponents/common/AudienceMattersNotifications'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import {
    // PERMISSIONS_OLD,
    ROLES,
  } from '@/appLogic/permissions/Constants.js'
  import ActionButton from '@/components/common/actionButton'
  import StepperModal from '@/appComponents/targets/createTarget/stepper/StepperModal'
  import SendDownstream from '@/appComponents/workbench/sendDownstream/SendDownstream'
  import { SET_SHOW_MODAL_STEPPER, SET_INTENTS } from '@/appLogic/targets/createTarget/store/actions'
  import { INTENTS, TARGET_ACTIONS } from '@/appLogic/targets/Constants'
  import Modal from '@/components/common/modal'
  import store from '@/store'
  import { SIGN_OUT } from '@/store/modules/auth/constants'
  import { cloneDeep } from 'lodash'
  import Toast from '@/components/common/toasts'

  export default {
    components: {
      AudienceMattersNotifications,
      ActionButton,
      StepperModal,
      SendDownstream,
      Modal,
    },
    props: {
      title: {
        type: String,
        default: 'Dashboard',
      },
    },
    data() {
      return {
        popover: null,
        Research: INTENTS.Research.Name,
        Marketing: INTENTS.Marketing.Name,
        Sales: INTENTS.Sales.Name,
        userPermissions: null,
      }
    },
    computed: {
      initialTargetCopy: {
        get() {
          const defaultTarget = {
            destinations: [],
            display_name: '',
            target_datasource: null,
            advertiser: null,
            // target: TARGET_TYPE.LAS,
            username: this.$store.state.auth.username,
            viewing_stream: null,
            target_definition: {},
          }
          return cloneDeep(this.initialTarget) || defaultTarget
        },
        set(newVal) {
          // No action needed
        },
      },
      username() {
        return this.$store.getters.username
      },
      userRoles() {
        let userRoles = this.$store.getters.userRoles.roles
        let userProfiles = []
        for (const userRole in userRoles) {
          if (userRoles.hasOwnProperty(userRole) && userRoles[userRole]) {
            let role = ROLES.find(role => {
              return role.value === parseInt(userRole)
            })
            if (role) {
              userProfiles.push(role['name'])
            }
          }
        }
        return userProfiles.join(', ')
      },
      showUserProfile() {
        return process.env.DISPLAY_PROFILE
      },
      authPermissions() {
        return this.$store.state.auth.permissions || []
      },
      intents() {
        let intents = []
        this.hasCreateEditPermissions && intents.push(this.Sales)
        // AM-3571: With the new profile changes Sales is the only available intent
        // this.authPermissions.find(p => p === PERMISSIONS_OLD.MARKETING_CREATE_EDIT) && intents.push(this.Marketing)
        // this.authPermissions.find(p => p === PERMISSIONS_OLD.AD_SALES_CREATE_EDIT) && intents.push(this.Sales)
        // this.authPermissions.find(p => p === PERMISSIONS_OLD.RESEARCH_CREATE_EDIT) && intents.push(this.Research)
        return intents
      },
      doesUserHaveAdminPermissions() {
        return this.$store.getters.hasAdminPagePermission
      },
      initialTarget() {
        return this.$store.getters.initialTarget
      },
      showActivationModalTrigger() {
        return this.$store.state.createTarget.initialTargetAction
      },
      hasCreateEditPermissions() {
        return this.$store.getters.hasCreateEditPermissions
      },
    },
    methods: {
      intentSelected(v) {
        this.$store.dispatch(SET_INTENTS, [v])
        if (v === INTENTS.Sales.Name) {
          this.$store.dispatch(SET_SHOW_MODAL_STEPPER, { step: 3 })
        } else {
          this.$store.dispatch(SET_SHOW_MODAL_STEPPER)
        }
        this.$refs.modal.close()
      },
      open() {
        this.$refs.modal.open()
      },
      createNewTarget() {
        console.log(this.intents)
        if (this.intents.length > 1) {
          this.open()
        } else if (this.intents[0]) {
          this.$store.dispatch(SET_INTENTS, this.intents)
          if (this.hasCreateEditPermissions) {
            this.$store.dispatch(SET_SHOW_MODAL_STEPPER, { step: 3 })
          } else {
            Toast.info({
              title: `Permission Denied`,
              message: `You do not have the permissions to create new segment. Please reach out to AM team to request permissions`,
            })
            // this.$store.dispatch(SET_SHOW_MODAL_STEPPER)
          }
        } else {
          Toast.info({
            title: `Permission Denied`,
            message: `You do not have the permissions to create new segment. Please reach out to AM team to request permissions`,
          })
        }
      },
      expandHeaderMenu(e) {
        this.popover = createPopover({
          parent: e.currentTarget,
          list: this.popoverMenuOptions(),
          type: popoverTypes.TEXTLIST,
          direction: 'bottom',
          align: 'left',
        })

        this.popover.$on('select', option => this.handlePopoverMenuOptions(option))
      },
      handlePopoverMenuOptions(option) {
        if (option === 'ADMIN' && this.doesUserHaveAdminPermissions) {
          let route = this.$router.resolve({ name: `Permissions`, path: `/admin/permissions` })
          window.open(route.href, '_blank')
        } else if (option === 'SIGN_OUT') {
          store.dispatch(SIGN_OUT)
        } else {
          return
        }
      },
      popoverMenuOptions() {
        if (this.doesUserHaveAdminPermissions) {
          return [
            {
              name: 'Admin',
              value: 'ADMIN',
            },
            {
              name: 'Sign Out',
              value: 'SIGN_OUT',
            },
          ]
        } else {
          return [
            {
              name: 'Sign Out',
              value: 'SIGN_OUT',
            },
          ]
        }
      },
    },
    watch: {
      showActivationModalTrigger() {
        if (this.showActivationModalTrigger === TARGET_ACTIONS.ACTIVATE) {
          this.$refs.sendDownstreamModal.open()
        }
      },
      initialTarget() {
        this.initialTargetCopy = cloneDeep(this.initialTarget)
      },
    },
  }
</script>

<style lang="scss">
  $headerBackgroundColor: #232a32;

  .popover-box__content {
    border: 2px solid black !important;
  }
  .headerMenuClickable {
    cursor: pointer;
  }

  .audience-hub-dashboard-header {
    grid-area: header;
    border-bottom: 1px solid black;
    padding: 5px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $headerBackgroundColor;

    .menu-container .menu-bar-con .menu-bar-btn {
      background-color: color(yellow) !important;
    }

    &__title {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 1em;
      color: white;
    }

    &__right-area {
      display: flex;
      align-items: center;
      color: white;
    }

    &__notifications {
      display: inline-block;
    }

    &__username {
      margin-left: 10px;
    }

    &__user-profile {
      margin-right: 20px;
    }

    &__create-target {
      margin-right: 50px;
      color: white;
    }

    &__select-intent-actions {
      display: flex;
      justify-content: center;
      button + button {
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AudienceHubDashboardHeader.vue?40acc6e0